import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../projectMaster/projectMaster.scss";
import DeleteModal from "../../components/common/DeleteModal";
import urls from "../../constants";
import FetchData, { DeleteEntry, GetList } from "../../providers/dataProvider";
import DataFilter from "../../utils/DataFilter";
import DataSearch from "../../utils/DataSearch";
import { CheckNull } from "../../utils/Validate";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import { useRolePermission } from "../../hooks/useRolePermission";
import DataTable from "../../components/common/DataTable";
import { SearchComponent } from "../../components/common/SearchComponent";
import ErrorMessage from "../../components/common/ErrorMessage";
import ProjectFilterComponent from "../../components/projectMaster/ProjectFilterComponent";
import ProjectGrid from "../../components/projectMaster/ProjectGrid";
import AdvancedFilterDropdown from "../../components/common/AdvancedFilterDropdown";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import {
  SuccessMessages,
  ErrorMessages,
} from "../../constants/MessageConstants";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};
const ProjectMasterList = () => {
  const navigate = useNavigate();

  const [ProjectFilter, setProjectFilter] = useState({
    MEPCustomer: [],
    MainCustomer: [],
    Distributor: [],
    DesignCustomer: [],
    SuperCustomer: [],
    Country: [],
    status: [],
  });

  const [ProjectData, setProjectData] = useState([]);
  const [MEPCustomer, setMEPCustomer] = useState([]);
  const [MainCustomer, setMainCustomer] = useState([]);
  const [DesignCustomer, setDesignCustomer] = useState([]);
  const [SuperCustomer, setSuperCustomer] = useState([]);
  const [Country, setCountry] = useState([]);
  const [ProjectStatus, setStatus] = useState([]);
  const [Distributor, setDistributor] = useState([]);

  const [countryData, setCountryData] = useState([]);
  const [projectstatusData, setProjectstatusData] = useState([]);
  const [distributorData, setDistributorData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [mepCustomerDrp, setMEPCustomerdrp] = useState([]);
  const [mainCustomerDrp, setMainCustomerdrp] = useState([]);
  const [designCustomerDrp, setDesignCustomerdrp] = useState([]);
  const [superCustomerDrp, setSuperCustomerdrp] = useState([]);

  const [filteredResults, setfilterResult] = useState([]);
  const [deleteShow, setDeleteShow] = useState({
    show: false,
    item: "",
    title: "",
    textCode: "",
    text: "",
    loading: false,
  });
  const [createMsg, setCreateMsg] = useState(null);
  const [successShow, setSuccessShow] = useState(false);
  const [search, setSearch] = useState("");
  const [clrFilter, setClrFilter] = useState(false);
  const [refreshSearch, setRefreshSearch] = useState(false);
  const [selected, setSelected] = useState([]);
  const [refreshData, setRefreshData] = useState([]);
  const [filterColumn, setFilterColumn] = useState([]);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });

  const { menuRights } = useRolePermission("Project Master");

  const {
    data: projectdata,
    loading: projectLoading,
    error: projectError,
  } = FetchData("project");
  const {
    data: countrydata,
    loading: countryLoading,
    error: countryError,
  } = FetchData("country");
  const {
    data: customerdata,
    loading: customerLoading,
    error: customerError,
  } = FetchData("Customer");
  const {
    data: distributordata,
    loading: distributorLoading,
    error: distributorError,
  } = FetchData("distributor");
  const {
    data: projectstatus,
    loading: prjstaLoading,
    error: prjstaError,
  } = FetchData("projectstatus");
  const {
    data: projectsegment,
    loading: prjSegLoading,
    error: prjSegError,
  } = FetchData("projectsegment");

  useEffect(() => {
    let filterdata = ProjectData.map((filterItem, index) => {
      let countryName = "";

      var countryValue = countrydata.filter(function (item) {
        return item.id === filterItem.countryId;
      });

      if (countryValue) countryName = countryValue[0]?.name;
      filterItem.Country = countryName;

      filterItem.ProjectInfo =
        filterItem.projectCode + "<br>" + filterItem.projectName;

      var mainContractor = customerdata.filter(function (item) {
        return item.id === filterItem.mainContractorId;
      });
      if (mainContractor?.length > 0)
        mainContractor = mainContractor[0]?.customerName;
      else mainContractor = "";

      var mepContractor = customerdata.filter(function (item) {
        return item.id === filterItem.mepContractorId;
      });
      if (mepContractor?.length > 0)
        mepContractor = mepContractor[0]?.customerName;
      else mepContractor = "";

      var distributor = distributordata.filter(function (item) {
        return item.id === filterItem.distributorId;
      });
      if (distributor?.length > 0)
        distributor = distributor[0]?.distributorName;
      else distributor = "";

      var designCustomer = customerdata.filter(function (item) {
        return item.id === filterItem.designConultantId;
      });
      if (designCustomer?.length > 0)
        designCustomer = designCustomer[0]?.customerName;
      else designCustomer = "";

      var superCustomer = customerdata.filter(function (item) {
        return item.id === filterItem.supervisionConsultantId;
      });
      if (superCustomer?.length > 0)
        superCustomer = superCustomer[0]?.customerName;
      else superCustomer = "";

      var clientCustomer = customerdata.filter(function (item) {
        return item.id === filterItem.clientId;
      });
      if (clientCustomer?.length > 0)
        clientCustomer = clientCustomer[0]?.customerName;
      else clientCustomer = "";

      filterItem.ContractorInfo =
        "Main : " + mainContractor + "<br> MEP : " + mepContractor;
      filterItem.MEPCustomer = mepContractor;
      filterItem.MainCustomer = mainContractor;
      filterItem.Distributor = distributor;
      filterItem.DesignCustomer = designCustomer;
      filterItem.SuperCustomer = superCustomer;
      filterItem.ClientCustomer = clientCustomer;
      var projectStatus = projectstatus.filter(function (item) {
        return item.id === filterItem.projectStatusId;
      });
      if (projectStatus) projectStatus = projectStatus[0]?.statusName;

      var projectSegment = projectsegment.filter(function (item) {
        return item.id === filterItem.projectSegmentId;
      });
      if (projectSegment) projectSegment = projectSegment[0]?.segmentName;

      filterItem.ProjectSegment = projectSegment;
      filterItem.Quoted = "";
      filterItem.ProjectStatus = projectStatus;

      return filterItem;
    });

    filterdata = [...filterdata].sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });

    setfilterResult(filterdata);
  }, [
    ProjectData,
    countrydata,
    customerdata,
    projectstatus,
    distributordata,
    projectsegment,
  ]);

  useEffect(() => {
    if (projectdata) {
      setProjectData(projectdata);
    }
  }, [projectdata]);

  const SuccessDoneClick = () => {
    setSuccessShow(false);
    GetList("project", "", setRefreshData);
  };

  useEffect(() => {
    if (refreshData?.message === "success") {
      setProjectData(refreshData?.data);
    }
  }, [refreshData]);

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked;
    if (activeData == false) {
      setSelected((oldData) => [...oldData, e.target.value]);
    } else {
      setSelected(selected.filter((values) => values !== e.target.value));
    }
  };

  useEffect(() => {
    let value = baseColumns.filter(({ value }) => !selected.includes(value));
    setFilterColumn(value);
  }, [selected]);

  useEffect(() => {
    setCustomerData(customerdata);
  }, [customerdata]);

  useEffect(() => {
    setDistributorData(distributordata);
  }, [distributordata]);

  useEffect(() => {
    setCountryData(countrydata);
  }, [countrydata]);

  useEffect(() => {
    setProjectstatusData(projectstatus);
  }, [projectstatus]);

  useEffect(() => {
    const getCustomerData = () => {
      if (customerData) {
        const mepCustType = customerData.filter(function (item) {
          return item.type.includes(urls.MEP_CUSTOMER);
        });
        setMEPCustomerdrp(mepCustType);

        const mainCustType = customerData.filter(function (item) {
          return item.type.includes(urls.MAIN_CUSTOMER);
        });
        setMainCustomerdrp(mainCustType);

        const designCustType = customerData.filter(function (item) {
          return item.type.includes(urls.DESIGN_CONSULTANT_CUSTOMER);
        });
        setDesignCustomerdrp(designCustType);

        const superCustType = customerData.filter(function (item) {
          return item.type.includes(urls.SUPER_VISION_CONSULTANT_CUSTOMER);
        });
        setSuperCustomerdrp(superCustType);
      }
    };
    getCustomerData();
  }, [customerData]);

  const statusdrp = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
  ];

  const handleFilterChange = (selectedOption, params) => {
    if (params === "MEPCustomer") setMEPCustomer(selectedOption);
    if (params === "MainCustomer") setMainCustomer(selectedOption);
    if (params === "DesignCustomer") setDesignCustomer(selectedOption);
    if (params === "SuperCustomer") setSuperCustomer(selectedOption);
    if (params === "Distributor") setDistributor(selectedOption);
    if (params === "Country") setCountry(selectedOption);
    if (params === "ProjectStatus") setStatus(selectedOption);

    setProjectFilter({
      ...ProjectFilter,
      [params]: selectedOption.map(({ label }) => label),
    });
  };

  const baseColumns = [
    {
      heading: "Project Info",
      value: "ProjectInfo",
      sortable: true,
    },
    {
      heading: "Contractor Info",
      value: "ContractorInfo",
      sortable: true,
    },
    {
      heading: "Quoted",
      value: "Quoted",
      sortable: true,
    },

    {
      heading: "Project Segment",
      value: "ProjectSegment",
      sortable: true,
    },

    {
      heading: "Country",
      value: "Country",
      sortable: true,
    },
    {
      heading: "Project Status",
      value: "ProjectStatus",
      sortable: true,
    },
  ];

  const handleEdit = (item) => {
    if (item)
      navigate("/add-new-project", {
        state: {
          row: item,
          id: item?.id,
          canAdd: menuRights?.canAdd,
          canEdit: menuRights?.canEdit,
        },
      });
  };

  const handleDelete = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: "You want delete this Project?",
      textCode: "Project Name",
      text: item?.projectName,
      loading: false,
    });
  };

  const handleCancelDelete = () => {
    setDeleteShow({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
    });
  };

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  const handleConfirmDelete = (item) => {
    setDeleteShow({
      ...deleteShow,
      loading: true,
    });
    DeleteEntry(
      "project",
      item,
      setCreateMsg,
      SuccessMessages?.DELETED("Project"),
      ErrorMessages?.DELETED_ERROR("Project")
    );
  };

  useEffect(() => {
    if (createMsg?.successData === "Successful") {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({
          show: false,
          item: "",
          title: "",
          textCode: "",
          text: "",
          loading: false,
        });
        setSuccessShow(true);
      }
    } else {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({
          show: false,
          item: "",
          title: "",
          textCode: "",
          text: "",
          loading: false,
        });
        setErrorShow({ show: true, errorMessage: createMsg.message });
      }
    }
  }, [createMsg]);

  const ClearFilter = () => {
    setProjectFilter({
      MEPCustomer: [],
      MainCustomer: [],
      Distributor: [],
      DesignCustomer: [],
      SuperCustomer: [],
      Country: [],
      ProjectStatus: [],
    });
    setMEPCustomer([]);
    setMainCustomer([]);
    setDesignCustomer([]);
    setSuperCustomer([]);
    setCountry([]);
    setDistributor([]);
    setStatus([]);
    setClrFilter(true);
  };

  const RefreshList = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (clrFilter === true) ApplyFilter();
  }, [clrFilter]);

  const ApplyFilter = () => {
    let filterResult = [];
    filterResult = DataFilter(ProjectData, ProjectFilter);
    filterResult = DataSearch(filterResult, search, baseColumns);

    filterResult = [...filterResult].sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    setfilterResult(filterResult);
    setClrFilter(false);
  };

  const ApplySearch = () => {
    let SearchResult = [];
    SearchResult = DataSearch(ProjectData, search, baseColumns);
    SearchResult = DataFilter(SearchResult, ProjectFilter);
    SearchResult = [...SearchResult].sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    setfilterResult(SearchResult);
    setRefreshSearch(false);
  };

  useEffect(() => {
    let value = baseColumns.filter(({ value }) => !selected.includes(value));
    setFilterColumn(value);
  }, [selected]);

  useEffect(() => {
    if (refreshSearch === true) ApplySearch();
  }, [search]);

  const removeSearch = () => {
    setSearch("");
    setRefreshSearch(true);
  };

  const addNew = () => {
    navigate("/add-new-project", {
      state: {
        canAdd: menuRights?.canAdd,
        canEdit: menuRights?.canEdit,
      },
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      ApplySearch();
    }
  };

  const handleView = (item) => {
    navigate("/view-project", {
      state: item,
    });
  };
  const hasActiveFilters = Boolean(
    MEPCustomer?.length ||
    MainCustomer?.length ||
    DesignCustomer?.length ||
    SuperCustomer?.length ||
    Country?.length ||
    ProjectStatus?.length ||
    Distributor?.length
  );
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));

  return (
    <>
      <section className="projects-list-sec" id="projectMaster">
        <div className="container-fluid">
          <div className="row pt-0">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 py-1">
              <div className="card">
                <div className="card-body">
                  <div className="row search-area-row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                      <div>
                        <p>{filteredResults?.length} Results Found</p>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto p-0">
                      <SearchComponent
                        filteredResults={filteredResults}
                        search={search}
                        handleKeyDown={handleKeyDown}
                        setSearch={setSearch}
                        removeSearch={removeSearch}
                        ApplySearch={ApplySearch}
                        RefreshList={RefreshList}
                        baseColumns={baseColumns}
                        selected={selected}
                        handleChange={handleChange}
                        data={projectdata}
                        addNew={addNew}
                        menuRights={menuRights}
                        hasActiveFilters={hasActiveFilters}
                        filterContent={(closeFilter) => (
                          <AdvancedFilterDropdown
                            ApplyFilter={ApplyFilter}
                            ClearFilter={ClearFilter}
                            onCloseFilter={closeFilter}
                             startWithFirstOnly
                            fields={[
                              {
                                value: "Distributor",
                                label: "Distributor",
                                placeholder: PlaceHolder.SELECT_DISTRIBUTOR,
                                pageName: "project",
                                dpDownName: "distributor",
                                data: distributorData,
                                valueObject: Distributor,
                                valueId: ProjectFilter?.Distributor,
                                setState: setDistributor,
                                multiSelect: true,
                                checkLabel: true,
                                hidden: userProfile?.userType !== 1,
                                onChange: (e) => handleFilterChange(e || [], "Distributor"),
                              },
                              {
                                value: "MainCustomer",
                                label: "Main Contractor",
                                placeholder: PlaceHolder.SELECT_MAIN_CUSTOMER,
                                pageName: "project",
                                dpDownName: "customer",
                                data: mainCustomerDrp,
                                valueObject: MainCustomer,
                                valueId: ProjectFilter?.MainCustomer,
                                setState: setMainCustomer,
                                multiSelect: true,
                                checkLabel: true,
                                onChange: (e) => handleFilterChange(e || [], "MainCustomer"),
                              },
                              {
                                value: "MEPCustomer",
                                label: "MEP Contractor",
                                placeholder: PlaceHolder.SELECT_MEP_CUSTOMER,
                                pageName: "project",
                                dpDownName: "customer",
                                data: mepCustomerDrp,
                                valueObject: MEPCustomer,
                                valueId: ProjectFilter?.MEPCustomer,
                                setState: setMEPCustomer,
                                multiSelect: true,
                                checkLabel: true,
                                onChange: (e) => handleFilterChange(e || [], "MEPCustomer"),
                              },
                              {
                                value: "DesignCustomer",
                                label: "Design Consultant",
                                placeholder: PlaceHolder.SELECT_DESIGN_CONSULTANT,
                                pageName: "project",
                                dpDownName: "customer",
                                data: designCustomerDrp,
                                valueObject: DesignCustomer,
                                valueId: ProjectFilter?.DesignCustomer,
                                setState: setDesignCustomer,
                                multiSelect: true,
                                checkLabel: true,
                                onChange: (e) => handleFilterChange(e || [], "DesignCustomer"),
                              },
                              {
                                value: "SuperCustomer",
                                label: "Supervision Consultant",
                                placeholder: PlaceHolder.SELECT_SUPER_CONSULTANT,
                                pageName: "project",
                                dpDownName: "customer",
                                data: superCustomerDrp,
                                valueObject: SuperCustomer,
                                valueId: ProjectFilter?.SuperCustomer,
                                setState: setSuperCustomer,
                                multiSelect: true,
                                checkLabel: true,
                                onChange: (e) => handleFilterChange(e || [], "SuperCustomer"),
                              },
                              {
                                value: "ProjectStatus",
                                label: "Status",
                                placeholder: PlaceHolder.SELECT_STATUS,
                                pageName: "project",
                                dpDownName: "projectstatus",
                                data: projectstatus,
                                valueObject: ProjectStatus,
                                valueId: ProjectFilter?.ProjectStatus,
                                setState: setStatus,
                                multiSelect: true,
                                checkLabel: true,
                                onChange: (e) => handleFilterChange(e || [], "ProjectStatus"),
                              },
                              {
                                value: "Country",
                                label: "Country",
                                placeholder: PlaceHolder.SELECT_COUNTRY,
                                pageName: "project",
                                dpDownName: "country",
                                data: countryData,
                                valueObject: Country,
                                valueId: ProjectFilter?.Country,
                                setState: setCountry,
                                multiSelect: true,
                                checkLabel: true,
                                onChange: (e) => handleFilterChange(e || [], "Country"),
                              },
                            ]}
                          />
                        )}
                      />
                      {/* <!-- search-area-sec ends --> */}
                    </div>
                  </div>
                  {/* <!-- search-area-sec ends --> */}
                </div>
              </div>
            </div>
          </div>
          <ProjectGrid
            filteredResults={filteredResults}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
            loading={projectLoading}
            menuRights={menuRights}
            moduleName="project"
          />
        </div>
      </section>
      <div className="container-fluid project-master-list-sec pl-5 pr-5">
        {/* // <!-- filter modal start--> */}
        <ProjectFilterComponent
          handleFilterChange={handleFilterChange}
          ProjectFilter={ProjectFilter}
          setMainCustomer={setMainCustomer}
          mainCustomerDrp={mainCustomerDrp}
          MainCustomer={MainCustomer}
          setMEPCustomer={setMEPCustomer}
          mepCustomerDrp={mepCustomerDrp}
          MEPCustomer={MEPCustomer}
          distributorData={distributorData}
          Distributor={Distributor}
          setDistributor={setDistributor}
          designCustomerDrp={designCustomerDrp}
          DesignCustomer={DesignCustomer}
          setDesignCustomer={setDesignCustomer}
          superCustomerDrp={superCustomerDrp}
          SuperCustomer={SuperCustomer}
          setSuperCustomer={setSuperCustomer}
          statusdrp={statusdrp}
          projectstatus={projectstatus}
          ProjectStatus={ProjectStatus}
          setStatus={setStatus}
          countryData={countryData}
          Country={Country}
          ClearFilter={ClearFilter}
          setCountry={setCountry}
          ApplyFilter={ApplyFilter}
        />
        {/* // <!-- filter modal end --> */}

        {/* // <!-- deleteModal start--> */}
        <DeleteModal
          deleteShow={deleteShow}
          handleCancelDelete={handleCancelDelete}
          handleConfirmDelete={handleConfirmDelete}
        />
        <ErrorMessage
          Show={errorShow?.show}
          errorMessage={errorShow?.errorMessage}
          ErrorDoneClick={ErrorDoneClick}
        />
        <SaveSuccessModel
          show={successShow}
          createMsg={createMsg}
          setShow={setSuccessShow}
          SuccessDoneClick={SuccessDoneClick}
        />
      </div>
    </>
  );
};

export default ProjectMasterList;
